// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Vow9x","title":"style_title__V7MTS","txnInformation":"style_txnInformation__FDexW","redirect":"style_redirect__Mot+H"};